import { RootState } from 'app/rootReducer'

export const rateTypesSelector = (state: RootState) => state.rateType.rateTypes
export const selectedRateTypeSelector = (state: RootState) =>
  state.rateType.selectedRateType
export const rateTypesIsLoadingSelector = (state: RootState) =>
  state.rateType.meta.isLoading
